import React from 'react';

import CustomProductBenefits from './CustomProductBenefits';
import { BenefitsData } from './CustomProductBenefits/models';

export interface CustomProductBenefitsPropsRaw {
  heading?: string;
  headingColor?: string;
  backgroundGradient?: string;
  desktopImage?: { url: string };
  mobileImage?: { url: string };
}

const CustomProductBenefitsWrapper = (props: CustomProductBenefitsPropsRaw) => {
  const { heading, headingColor, backgroundGradient, desktopImage, mobileImage } = props;

  const data: BenefitsData = {
    heading,
    headingColor,
    backgroundGradient,
    desktopImage,
    mobileImage,
  };

  return <CustomProductBenefits data={data} />;
};

CustomProductBenefitsWrapper.displayName = 'CustomProductBenefitsWrapper';
export default CustomProductBenefitsWrapper;
